import { Component, OnInit, Inject, VERSION } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import {CommonOptions, ModelSaveCarnetPrintResponse} from '../../../interfaces/interfaces';
import { PersonalService } from '../../../services/modules/personal.service';
import { VehicleService } from '../../../services/modules/vehicle.service';
import {CommonService} from '../../../services/modules/common.service';
import {JsonTypeVehiclesService} from '../../../services/json-service/json-typeVehiclesImg.service';

export interface DialogData {
  print: string;
  personalInfo: any;
}

@Component({
  selector: 'app-dialog-print-pre-carnet',
  templateUrl: './dialog-print-pre-carnet.component.html',
  styleUrls: ['./dialog-print-pre-carnet.component.scss']
})
export class DialogPrintPreCarnetComponent implements OnInit {
  s3Bucket: string;
  position = 'horizontal';
  print = true;

  itemSelected: any;
  isVehicle = false;

  // CODEQR
  name = 'ANALITYCO CARNET' + VERSION.major;
  elementType = NgxQrcodeElementTypes.CANVAS;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  valueQR = '';
  vehicleTypeAll: CommonOptions[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogPrintPreCarnetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private personalService: PersonalService,
    private vehicleService: VehicleService,
    private commonService: CommonService,
    private jsonTypeVehiclesService: JsonTypeVehiclesService,
  ) {
    this.itemSelected = data.personalInfo;

    this.isVehicle = this.itemSelected.IsVehicle;
    if (this.data.print === 'IMPRIMIR') {
      this.valueQR = this.itemSelected.CarnetCode;
    }
    if (this.isVehicle) {
      this.commonService.getCommonOptions('VehicleType').subscribe((data: CommonOptions[]) => {
        this.vehicleTypeAll = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      });
    }
  }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
  }

  rePrintCarnet(){
    if (this.isVehicle) {
      this.rePrintCarnetVehicle();
    } else {
      this.rePrintCarnetPersonal();
    }
  }

  private rePrintCarnetVehicle(): void {
    if (this.data.print === 'GENERAR') {
      // Para vehículos, usar el Id como vehicleId
      const vehicleId = this.itemSelected.Id;
      this.vehicleService.postVehicleCarnet(vehicleId).subscribe({
        next: (response: any) => {
          this.valueQR = response?.CarnetCode || response?.Code || '';
          this.print = false;
          setTimeout(() => {
            window.print();
          }, 500);
        },
        error: () => {
          // En caso de error, intentar imprimir con el código existente
          this.print = false;
          setTimeout(() => {
            window.print();
          }, 500);
        }
      });
    } else if (this.data.print === 'IMPRIMIR') {
      const vehicleId = this.itemSelected.Id;
      this.vehicleService.getVehicleCarnet(vehicleId).subscribe({
        next: (response: any) => {
          // Ajusta las props según tu API real
          this.valueQR = response?.CarnetCode || response?.Code || '';
          if (response?.DocumentType) {
            this.itemSelected.DocumentType = response.DocumentType;
          }
          this.print = false;
          setTimeout(() => window.print(), 500);
        },
        error: () => {
          this.print = false;
          setTimeout(() => window.print(), 500);
        }
      });
    }
  }

  private rePrintCarnetPersonal(): void {
    if (this.data.print === 'GENERAR') {
      if (this.itemSelected.CarnetId === null || this.itemSelected.CarnetId === undefined) {
        this.personalService.printSaveCarnet({
          EmployerId: this.itemSelected.EmployerId === null ?
            this.itemSelected.SubContractorId : this.itemSelected.EmployerId,
          IsActive: this.itemSelected.IsActive,
          PersonalCompanyInfoId: this.itemSelected.PersonalCompanyInfoId,
        }).subscribe((modelSaveCarnetPrintResponse: ModelSaveCarnetPrintResponse) => {
          this.valueQR = modelSaveCarnetPrintResponse.Code;
          this.print = false;
          setTimeout(function(){
          window.print();
          }, 500);
        });
      } else {
        this.personalService.printSaveCarnetPATCH(this.itemSelected.CarnetId).subscribe(() => {
          this.personalService.printSaveCarnet({
            EmployerId: this.itemSelected.EmployerId === null ?
              this.itemSelected.SubContractorId : this.itemSelected.EmployerId,
            IsActive: this.itemSelected.IsActive,
            PersonalCompanyInfoId: this.itemSelected.PersonalCompanyInfoId,
          }).subscribe((modelSaveCarnetPrintResponse: ModelSaveCarnetPrintResponse) => {
            this.valueQR = modelSaveCarnetPrintResponse.Code;
            this.print = false;
            setTimeout(function(){
            window.print();
            }, 500);
          });
        });
      }
    } else if (this.data.print === 'IMPRIMIR') {
      this.print = false;
      setTimeout(function(){
      window.print();
      }, 500);
    }
  }

  onNoClick(): void {
    if (this.data.print === 'GENERAR' && this.valueQR !== ''){
      this.dialogRef.close('GENERADO');
    } else if (this.valueQR === ''){
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
    }
  }

  getImgVehicle(photo) {
    let img = '';
    if (photo === '' || photo === null || photo === undefined) {
      const typeName = this.getVehicleType(this.itemSelected.VehicleTypeId || null);
      const url = this.getIMGVehicleType(typeName);
      img = (url === null || url === undefined || url === '' ? this.s3Bucket + 'assets/images/ic_unknow_car.png' : this.s3Bucket + url);
    } else {
      img = this.s3Bucket + photo;
    }
    return img;
  }

  getVehicleType(Id): string {
    let type = '';
    const data = this.vehicleTypeAll.find(x => x.Id === Id);
    type = data?.Value ?? '';
    return type;
  }

  getDocumentTypeLabel(docType: string): string {
    return docType === 'REGISTRO_MAQUINARIA' ? 'Registro de Maquinaria' : 'Placa';
  }

  getIMGVehicleType(name): string {
    let url = '';
    const data = this.jsonTypeVehiclesService.serviceListVehicles.find(x => x.name === name);
    data !== undefined ? url = data.url : url = '';
    return url;
  }

}

